import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export var Line = function (_a) {
    var x = _a.x, y = _a.y, length = _a.length, _b = _a.isDotted, isDotted = _b === void 0 ? false : _b, _c = _a.direction, direction = _c === void 0 ? "horizontal" : _c, _d = _a.color, color = _d === void 0 ? "#FFFFFF" : _d, _e = _a.strokeWidth, strokeWidth = _e === void 0 ? 2 : _e;
    return (_jsx("path", { d: direction === "horizontal"
            ? "M ".concat(x, " ").concat(y, " L ").concat(x + length, " ").concat(y)
            : "M ".concat(x, " ").concat(y, " L ").concat(x, " ").concat(y + length), stroke: color, strokeDasharray: isDotted ? "2,2" : "auto", strokeWidth: strokeWidth }));
};
